/*!
 *  2018-11-29 18:04:00
 *  Copyright 2018 FT, DK Techin Corp 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _clipList = __webpack_require__(44);
	
	var _clipList2 = _interopRequireDefault(_clipList);
	
	var _videoCollection = __webpack_require__(23);
	
	var _videoCollection2 = _interopRequireDefault(_videoCollection);
	
	var _videoPlayer = __webpack_require__(35);
	
	var _videoPlayer2 = _interopRequireDefault(_videoPlayer);
	
	var _api = __webpack_require__(16);
	
	var api = _interopRequireWildcard(_api);
	
	var _converter = __webpack_require__(19);
	
	var _converter2 = _interopRequireDefault(_converter);
	
	var _jqdomStatic = __webpack_require__(45);
	
	var _logger = __webpack_require__(32);
	
	var logger = _interopRequireWildcard(_logger);
	
	var _cpMeta = __webpack_require__(4);
	
	var _cpMeta2 = _interopRequireDefault(_cpMeta);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Module Instantiations
	var videoCollection = new _videoCollection2['default'](_converter2['default'].convert(C.VO2.data.clips));
	var videoPlayer = _videoPlayer2['default'].create();
	var clipList = _clipList2['default'].create({ expender: _jqdomStatic.$extendBtn, container: _jqdomStatic.$listWrap });
	
	// Define Event Listeners
	clipList.on('more', fetchAPISource).on('itemClick', function (e, elem) {
	  var clip = videoCollection.get({ id: (0, _jquery2['default'])(elem).data('vid'), where: 'collection' });
	  var isClosingAction = clipList.indexOfHighlighted === clip.index;
	
	  videoPlayer.close();
	
	  if (!isClosingAction) {
	    videoPlayer.open(clip);
	    moveScrollPosition((0, _jquery2['default'])(e.target));
	  }
	
	  logger.togglePlayerLog(e, isClosingAction, videoCollection.length, clip, elem);
	}).on('expand', logger.unfoldLog.bind(null)).on('fold', function (e) {
	  // 펼쳐보기를 접을때 총 5개의 리스트만 노출이 되는데, 열려있는 플레이어가 해당 리스트에 속하지 않을 경우 닫는다.
	  if (clipList.indexOfHighlighted >= clipList.viewCount) {
	    videoPlayer.close();
	  }
	  logger.foldLog(e);
	});
	
	videoPlayer.on('open', renderPlayer).on('switch', function (e) {
	  var _e$detail = e.detail,
	      clipData = _e$detail.clipData,
	      nowPlaying = _e$detail.nowPlaying;
	
	  logger.playlistLog({
	    clip: _jquery2['default'].extend({}, clipData, { index: clipList.indexOfHighlighted || 0 }),
	    rc: clipList.length,
	    evt: e
	  });
	  logger.sendS2Log(clipData, nowPlaying);
	}).on('destroy', clipList.highlight.bind(clipList, -1));
	
	logger.staticLogs(_jqdomStatic.$ctx, {
	  definitions: {
	    '3': { at: 'link', p: 3 },
	    '11': { at: 'link', p: 11 },
	    '18': { at: 'link', p: 18 },
	    '21': { at: 'link', p: 21 },
	    '28': { at: 'link', p: 28 },
	    '31': { at: 'link', p: 31 },
	    '34': {
	      at: 'link',
	      p: 34,
	      extParamSetter: function extParamSetter(clip) {
	        switch (true) {
	          case clip.isOrgDoc:
	          case clip.isKakaoTVPlaylist:
	            return {
	              cpId: clip.cp,
	              channelId: clip.bifChannelId,
	              isSMR: clip.isSMR,
	              isLive: false
	            };
	          case clip.cp === _cpMeta2['default'].codes.KAKAOTV_NO_LIVE:
	            return {
	              cpId: _cpMeta2['default'].codes.KAKAOTV_NO_LIVE,
	              channelId: '',
	              isSMR: '',
	              isLive: false
	            };
	          case clip.cp === _cpMeta2['default'].codes.YOUTUBE:
	            return {
	              cpId: _cpMeta2['default'].codes.YOUTUBE,
	              channelId: _cpMeta2['default'].codes.YOUTUBE_CHANNEL_ID,
	              isSMR: false,
	              isLive: false
	            };
	          default:
	            return {
	              cpId: clip.cp,
	              channelId: clip.bifChannelId,
	              isSMR: clip.isSMR,
	              isLive: false
	            };
	        }
	      }
	    }
	  },
	  getResultCount: function getResultCount() {
	    return clipList.length;
	  },
	  nowPlaying: function nowPlaying() {
	    return videoPlayer.nowPlaying();
	  },
	  getClipByIndex: function getClipByIndex(idx) {
	    return videoCollection.getByIndex(idx);
	  }
	});
	
	// Define Callbacks
	function renderPlayer(clip) {
	  clipList.insertTo(clip.index, videoPlayer.$player).highlight(clip.index);
	  renderPlayList(clip);
	}
	
	function fetchAPISource(renderToClipList) {
	  api.fetchClips().done(function (res) {
	    clipList.isEnd = res.isEnd;
	    var data = _converter2['default'].convert(res.data);
	    videoCollection.push(data);
	    renderToClipList(data);
	  });
	}
	
	function renderPlayList(clip) {
	  var relatedClips = videoCollection.get({ id: clip.videoId, where: 'playlist' });
	  var toTemplateData = _converter2['default'].mapClipToPlaylistTemplateData.bind(null, clip);
	
	  if (relatedClips) {
	    videoPlayer.renderPlayList(toTemplateData(relatedClips));
	    return;
	  }
	
	  api.fetchRelatedClips(clip).then(function (res) {
	    if (_jquery2['default'].isEmptyObject(res)) {
	      videoPlayer.closeFooter();
	    } else {
	      var data = _converter2['default'].playlistToClipFormat(clip, res);
	
	      videoCollection.assign(clip.videoId, data);
	      videoPlayer.renderPlayList(toTemplateData(data));
	    }
	  }).fail(function (err) {
	    console.error(err);
	    videoPlayer.closeFooter();
	  });
	}
	
	function moveScrollPosition($target) {
	  var marginTop = 19;
	  var scrollTop = $target.offset().top;
	  _jqdomStatic.$document.stop().animate({ scrollTop: scrollTop - marginTop }, 300);
	}

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function create(prototype) {
	  function F() {}
	  F.prototype = prototype;
	  return new F();
	}
	
	function inherit(subclass, superclass, newProto) {
	  var proto = create(superclass.prototype);
	  subclass.prototype = _jquery2['default'].extend(proto, newProto);
	  subclass.prototype.constructor = subclass;
	}
	
	exports['default'] = inherit;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * event-emmiter 구현체 from https://gist.github.com/mudge/5830382
	 */
	function EventEmitter() {
	  this.events = {};
	}
	
	EventEmitter.prototype.on = function (event, listener) {
	  if (_typeof(this.events[event]) !== 'object') {
	    this.events[event] = [];
	  }
	
	  this.events[event].push(listener);
	};
	
	EventEmitter.prototype.removeListener = function (event, listener) {
	  var idx;
	
	  if (_typeof(this.events[event]) === 'object') {
	    idx = this.events[event].indexOf(listener);
	
	    if (idx > -1) {
	      this.events[event].splice(idx, 1);
	    }
	  }
	};
	
	EventEmitter.prototype.emit = function (event) {
	  var i,
	      listeners,
	      length,
	      args = [].slice.call(arguments, 1);
	
	  if (_typeof(this.events[event]) === 'object') {
	    listeners = this.events[event].slice();
	    length = listeners.length;
	
	    for (i = 0; i < length; i++) {
	      listeners[i].apply(this, args);
	    }
	  }
	};
	
	EventEmitter.prototype.once = function (event, listener) {
	  this.on(event, function g() {
	    this.removeListener(event, g);
	    listener.apply(this, arguments);
	  });
	};
	
	exports['default'] = EventEmitter;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _define;
	
	var _cp = __webpack_require__(30);
	
	var cp = _interopRequireWildcard(_cp);
	
	var _types = __webpack_require__(10);
	
	var cpTypes = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var KAKAOTV_NO_LIVE = cp.KAKAOTV_NO_LIVE,
	    KAKAOTV_OPEN = cp.KAKAOTV_OPEN,
	    DAUM_BLOG = cp.DAUM_BLOG,
	    DAUM_CAFE = cp.DAUM_CAFE,
	    TISTORY = cp.TISTORY,
	    NAVER_BLOG = cp.NAVER_BLOG,
	    YOUTUBE = cp.YOUTUBE,
	    ETC = cp.ETC;
	var CP_TYPE_KAKAOTV = cpTypes.CP_TYPE_KAKAOTV,
	    CP_TYPE_YOUTUBE = cpTypes.CP_TYPE_YOUTUBE,
	    CP_TYPE_ETC = cpTypes.CP_TYPE_ETC;
	exports['default'] = {
	  codes: cp,
	  CPTypes: cpTypes,
	  docTypes: {
	    KAKAO_POPULAR: 'tvpotPopular',
	    KAKAO_PLAYLIST: 'tvpotPlaylist'
	  },
	  define: (_define = {}, _define[KAKAOTV_NO_LIVE] = {
	    type: CP_TYPE_KAKAOTV,
	    isFamily: true
	  }, _define[KAKAOTV_OPEN] = {
	    type: CP_TYPE_KAKAOTV,
	    isFamily: true
	  }, _define[DAUM_BLOG] = {
	    type: CP_TYPE_KAKAOTV,
	    isFamily: true
	  }, _define[DAUM_CAFE] = {
	    type: CP_TYPE_KAKAOTV,
	    isFamily: true
	  }, _define[TISTORY] = {
	    type: CP_TYPE_KAKAOTV,
	    isFamily: true
	  }, _define[NAVER_BLOG] = {
	    type: CP_TYPE_ETC,
	    isFamily: false
	  }, _define[YOUTUBE] = {
	    type: CP_TYPE_YOUTUBE,
	    isFamily: false
	  }, _define[ETC] = {
	    type: CP_TYPE_ETC,
	    isFamily: false
	  }, _define),
	  PDGrades: {
	    S: 'star',
	    A: 'pro',
	    B: 'rookie'
	  },
	  of: function of(cp) {
	    return this.define[cp] || this.define[ETC];
	  },
	  cpToType: function cpToType(cp) {
	    return this.of(cp).type;
	  },
	  PDGradeToClassName: function PDGradeToClassName(PDGrade) {
	    return this.PDGrades[PDGrade] || '';
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var YOUTUBE = exports.YOUTUBE = 'youtube';
	var KAKAOTV = exports.KAKAOTV = 'kakaotv';
	
	var PLAYLIST = exports.PLAYLIST = 'playlist';
	var RECOMMEND = exports.RECOMMEND = 'recommand';

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ITEM_CLICK = exports.ITEM_CLICK = 'itemClick';

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var DESTROY = exports.DESTROY = 'destroy';
	var LOAD = exports.LOAD = 'load';
	var READY = exports.READY = 'ready';
	var ERROR = exports.ERROR = 'error';

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var NAVIGATE = exports.NAVIGATE = 'navigate';
	var ITEM_CLICK = exports.ITEM_CLICK = 'itemClick';

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var LOAD = exports.LOAD = 'load';
	var DESTROY = exports.DESTROY = 'destroy';
	var ERROR = exports.ERROR = 'error';
	var READY = exports.READY = 'ready';
	var STATE_CHANGE = exports.STATE_CHANGE = 'stateChange';

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var CP_TYPE_KAKAOTV = exports.CP_TYPE_KAKAOTV = 'tvpot';
	var CP_TYPE_YOUTUBE = exports.CP_TYPE_YOUTUBE = 'youtube';
	var CP_TYPE_ETC = exports.CP_TYPE_ETC = 'etc';

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var OPEN = exports.OPEN = 'open';
	var NAVIGATE = exports.NAVIGATE = 'navigate';
	var READY = exports.READY = 'ready';
	var DESTROY = exports.DESTROY = 'destroy';
	var LOAD = exports.LOAD = 'load';
	var SWITCH = exports.SWITCH = 'switch';

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  itemSelector: '[data-type="preview"] [data-vid]'
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function gracefulErrorHandler(err) {
	  console.error(err);
	  return [];
	}
	
	exports["default"] = gracefulErrorHandler;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _error = __webpack_require__(13);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var query = decodeURIComponent(window.utf8Query);
	var p = 2;
	
	/**
	 * qsearch1에서 동영상 목록을 불러온다.
	 * @returns {jQuery.Deferred}
	 */
	function fetchClips() {
	  var params = {
	    q: query,
	    w: 'spread',
	    m: 'vclip_vod',
	    exp: 'VO2',
	    n: 5,
	    p: p,
	    dup_filter: 'y',
	    qsearch_ver: 'v2',
	    viewtype: 'json'
	  };
	  var qsearchURL = SF.getQsUrl(params, 1);
	  /* eslint-disable */
	  return _jquery2['default'].getJSON(qsearchURL).then(unwrapResponse, _error2['default']).fail(function (err) {
	    return console.error(err);
	  });
	  /* eslint-enable */
	}
	
	function unwrapResponse(res) {
	  var json = typeof res === 'string' ? JSON.parse(res) : res;
	  var r = json.RESULT.SPREAD_VCLIP_VOD.r;
	
	  var data = r.ds.data || [];
	
	  incrementPageParam();
	  return {
	    data: Array.isArray(data) ? data : [data],
	    isEnd: r.m.is_end.toLowerCase() === 'true'
	  };
	}
	
	function incrementPageParam() {
	  p++;
	}
	
	exports['default'] = fetchClips;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _cpMeta = __webpack_require__(4);
	
	var _cpMeta2 = _interopRequireDefault(_cpMeta);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *
	 * @param {string} cpType
	 * @param {string} kakaoTVType
	 * @param {string} dsid
	 * @param {string} playlistId
	 * @param {string} clipId
	 * @returns {string}
	 */
	function getRequestClipId(cpType, kakaoTVType, dsid, playlistId, clipId) {
	  var defaultId = '';
	  switch (cpType) {
	    case _cpMeta2['default'].CPTypes.CP_TYPE_YOUTUBE:
	      return dsid;
	    case _cpMeta2['default'].CPTypes.CP_TYPE_KAKAOTV:
	      return kakaoTVType === _constants.PLAYLIST ? playlistId : kakaoTVType === _constants.RECOMMEND ? clipId : defaultId;
	    default:
	      return defaultId;
	  }
	}
	
	/**
	 *
	 * 플레이어 하단에 표시될 관련 영상 데이터를 가져온다.
	 *
	 * @param cpType
	 * @param dsid
	 * @param kakaoTVType
	 * @param clipId
	 * @param kakaoTVPlaylistId
	 * @returns {jQuery.Deferred}
	 */
	function fetchRelatedClips(_ref) {
	  var cpType = _ref.cpType,
	      dsid = _ref.dsid,
	      kakaoTVType = _ref.kakaoTVType,
	      clipId = _ref.clipId,
	      kakaoTVPlaylistId = _ref.kakaoTVPlaylistId;
	
	  var id = getRequestClipId(cpType, kakaoTVType, dsid, kakaoTVPlaylistId, clipId);
	  if (!id) {
	    var d = _jquery2['default'].Deferred();
	    d.reject(new Error('clipId not found'));
	
	    return d;
	  }
	
	  var params = {
	    w: 'vclip',
	    m: 'ft_proxy',
	    viewtype: 'json',
	    q: '',
	    uuid: window.uuid,
	    type: cpType,
	    tvpot_type: kakaoTVType,
	    clip_id: clipId,
	    id: id
	  };
	  var qsearchURL = SF.getQsUrl(params, 1);
	  return _jquery2['default'].ajax({
	    url: qsearchURL,
	    dataType: 'json'
	  }).then(function (res) {
	    try {
	      return JSON.parse(res.RESULT.VCLIP_API_FT_PROXY.ROOT);
	    } catch (e) {
	      return {};
	    }
	  });
	}
	
	exports['default'] = fetchRelatedClips;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fetchRelatedClips = exports.fetchClips = undefined;
	
	var _fetchClips = __webpack_require__(14);
	
	var _fetchClips2 = _interopRequireDefault(_fetchClips);
	
	var _fetchRelatedClips = __webpack_require__(15);
	
	var _fetchRelatedClips2 = _interopRequireDefault(_fetchRelatedClips);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.fetchClips = _fetchClips2['default'];
	exports.fetchRelatedClips = _fetchRelatedClips2['default'];

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _inherit = __webpack_require__(2);
	
	var _inherit2 = _interopRequireDefault(_inherit);
	
	var _eventEmitter = __webpack_require__(3);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _events = __webpack_require__(6);
	
	var events = _interopRequireWildcard(_events);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 리스트 UI에 대한 기본 인터페이스를 제공한다.
	 * 통검의 경우 SF.expand와 결합하여 사용하며
	 * 탭의 경우 단일 리스트로서 활용한다.
	 *
	 * @param {jQuery|string} container - 리스트를 감싸는 컨테이너 엘리먼트 또는 해당 엘리먼트를 가리키는 셀렉터
	 * @param {string} [itemSelector="li"] - onItemClick 이벤트의 셀렉터. children과 다를 수 있다. 기본값은 li
	 * @param {string} [activeClassName="on"] - children 이 활성화 상태일때 부여할 클래스명 기본값은 on
	 * @param {number} [cols=1] - 한 줄에 표시되는 아이템의 갯수
	 * @constructor
	 * @augments EventEmitter
	 */
	function ClipList(_ref) {
	  var container = _ref.container,
	      itemSelector = _ref.itemSelector,
	      activeClassName = _ref.activeClassName,
	      _ref$cols = _ref.cols,
	      cols = _ref$cols === undefined ? 1 : _ref$cols;
	
	  _eventEmitter2['default'].call(this);
	
	  this.$container = (0, _jquery2['default'])(container);
	  this.itemSelector = itemSelector || 'li';
	  this.activeClassName = activeClassName || 'on';
	  this.indexOfHighlighted = -1;
	  this.length = this.getItems$().length;
	  this.cols = cols;
	  this._bindExtendedEvent();
	}
	
	(0, _inherit2['default'])(ClipList, _eventEmitter2['default'], {
	  /**
	   * 리스트 아이템을 클릭했을 때
	   * @emits PlayList#itemClick
	   * @private
	   */
	  _onItemSelect: function _onItemSelect() {
	    var self = this;
	    this.$container.on('click', this.itemSelector, function (e) {
	      self.emit(events.ITEM_CLICK, e, this);
	    });
	  },
	  _bindExtendedEvent: function _bindExtendedEvent() {
	    this._onItemSelect();
	  },
	
	
	  /**
	   * 지정된 index에 해당하는 리스트 아이템에 activeClassName을 부여한다. 해제하려면 -1을 넣어주면 된다.
	   * @param {string|number} idx - 하이라이팅 클래스를 적용할 대상 인덱스 (-1: 해제)
	   * @returns {ClipList}
	   */
	  highlight: function highlight(idx) {
	    var activeClassName = this.activeClassName;
	    var $children = this.getItems$();
	    $children.removeClass(activeClassName);
	    idx > -1 && $children.eq(idx).addClass(activeClassName);
	    this.indexOfHighlighted = idx;
	    return this;
	  },
	
	
	  /**
	   * jQuery 리스트 아이템을 리턴한다. itemSelector로 지정된것과 관련없이 컨테이너의 모든 자식 요소를 리턴하니 주의
	   * @returns {jQuery}
	   */
	  getItems$: function getItems$() {
	    return this.$container.children();
	  },
	
	
	  /**
	   * 지정된 리스트 위치에 HTML 요소를 삽입한다.
	   * @param {string|number} idx - 요소를 삽입할 리스트의 index
	   * @param {jQuery|HTMLElement|string} htmlContents - 삽입할 HTML
	   * @returns {ClipList}
	   */
	  insertTo: function insertTo(idx, htmlContents) {
	    (0, _jquery2['default'])(htmlContents).insertAfter(this.getItems$().eq(idx));
	    return this;
	  },
	
	
	  /**
	   * @param args
	   * @override
	   * @returns {ClipList}
	   */
	  on: function on() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _eventEmitter2['default'].prototype.on.apply(this, args);
	    return this;
	  },
	
	
	  /**
	   *
	   * 인덱스를 한 열에 있는 행의 최대 수로 환산해준다.
	   * 예를들어 한 행에 보이는 아이템의 갯수가 n이고
	   * n = 3이라면
	   * 0~2까지의 index는 2라는 index로 매핑되어야 한다.
	   * 3 ~ 5 는 5
	   * 6 ~ 8 은 8
	   *
	   * 그리드 뷰 아이템에 플레이어를 삽입하기 위해 사용한다.
	   * @param idx
	   * @returns {number}
	   */
	  indexToPlayerPos: function indexToPlayerPos(idx) {
	    var cols = this.cols;
	    var oneIndexed = idx + 1;
	    return Math.ceil(oneIndexed / cols) * cols - 1;
	  }
	});
	
	exports['default'] = ClipList;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _clipList = __webpack_require__(17);
	
	var _clipList2 = _interopRequireDefault(_clipList);
	
	var _events = __webpack_require__(6);
	
	var events = _interopRequireWildcard(_events);
	
	var _defaultConfigs = __webpack_require__(12);
	
	var _defaultConfigs2 = _interopRequireDefault(_defaultConfigs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _jquery2['default'].extend(_clipList2['default'], {
	  events: events,
	  create: function create(opts) {
	    return new _clipList2['default'](_jquery2['default'].extend({}, _defaultConfigs2['default'], opts));
	  }
	});

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _index = __webpack_require__(4);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _constants = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isUserReportMode = SF.getParam('cnucc') === "1";
	
	/**
	 *
	 * @type {{addComma: (function(*=): string), formatDate: (function(string): string), toVideoTimeFormat: (function((number|string)): string), kakaoTVType: (function(*): string), convert: (function(*): Clip)}}
	 */
	var Converter = {
	  /**
	   * @see {@link http://hehet.dev.daum.net/scripts/common/modules/number/index.html}
	   * @param {number} number
	   * @returns {string}
	   */
	  addComma: function addComma(number) {
	    return _jquery2['default'].number.addComma(number);
	  },
	
	  /**
	   * @see {@link http://hehet.dev.daum.net/scripts/common/modules/format/index.html}
	   * @param {string} yyyyMMddHHmmss
	   * @returns {string}
	   */
	  formatDate: function formatDate(yyyyMMddHHmmss) {
	    return _jquery2['default'].format.prettydate(yyyyMMddHHmmss);
	  },
	
	  /**
	   * 초를 동영상 시:분:초 포맷으로 환산한다. '시' 단위가 00: 일 경우는 제거하고 분이 00:이면 남겨둔다
	   * 00:04:11 => 04:11
	   * 00:00:11 => 00:11
	   * @param {number|string} seconds
	   * @returns {string}
	   */
	  toVideoTimeFormat: function toVideoTimeFormat(seconds) {
	    return new Date(seconds * 1000).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0].replace(/^00:/, '');
	  },
	  escapeNonTagString: function escapeNonTagString(str) {
	    var htmlRegex = /&lt;\s*b[^&gt;]*&gt;.*?&lt;\s*\/\s*b&gt;/g;
	    var escapeTagSigns = function escapeTagSigns(str) {
	      return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
	    };
	    var unescapeTags = function unescapeTags(str) {
	      return str.replace(htmlRegex, function ($m) {
	        return $m.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	      });
	    };
	    return unescapeTags(escapeTagSigns(str));
	  },
	
	  /**
	   * 카카오TV이면서 플레이리스트인 타입인지 구분. 리턴 값으로 동영상 하단이 추천영상인지 플레이리스트인지 구분된다.
	   * @param {string} playlistId
	   * @returns {string}
	   */
	  kakaoTVType: function kakaoTVType(playlistId) {
	    return playlistId === '' ? _constants.RECOMMEND : _constants.PLAYLIST;
	  },
	  makeDupURL: function makeDupURL(dup_orig_count, dup_docids) {
	    var periodParamObj = ['sd', 'ed', 'period'].map(function (param) {
	      return { param: SF.getParam(param), key: param };
	    }).filter(function (param) {
	      return !!param.param;
	    }).reduce(function (obj, param) {
	      var _$$extend;
	
	      return _jquery2['default'].extend(obj, (_$$extend = {}, _$$extend[param.key] = param.param, _$$extend));
	    }, {});
	    var mergedParams = _jquery2['default'].extend({
	      w: 'vclip',
	      q: decodeURIComponent(window.utf8Query),
	      dup_filter: 'n',
	      dup_orig_count: dup_orig_count,
	      dup_docids: dup_docids,
	      spacing: SF.getParam('spacing') || 0
	    }, periodParamObj);
	
	    return '?' + _jquery2['default'].param(mergedParams);
	  },
	
	  /**
	   * API 데이터를 프론트에서 사용할 데이터 포맷으로 변환한다
	   * @param {Object} ajaxData
	   * @returns {Clip}
	   */
	  convert: function convert(ajaxData) {
	    var _this = this;
	
	    return ajaxData.map(function (clip) {
	      var dupInfo = clip.dup_info || {};
	      var playCountInt = Number(clip.play_count) || 0;
	      var cp = clip.bif_cp_id;
	      var cpMeta = _index2['default'].of(cp);
	      var isEmbeddable = clip.is_embeddable === 'true';
	      var isYoutube = cp === _index2['default'].codes.YOUTUBE;
	      var isYoutubeRestrictedAge = clip.is_youtube_restricted_age === 'true';
	      var dupCount = Number(dupInfo.dup_orig_count || "0");
	      var isAdult = clip.is_adult === 'true';
	      var displayURL = clip.landing_url;
	      var thumbURL = clip.repr_thumbnail_url_s2;
	      var dsid = clip.dsid;
	      var totalPlayCount = _this.addComma(playCountInt);
	      var pdGradeIcon = _index2['default'].PDGradeToClassName(clip.kakao_tv_pd_level);
	      var shouldDisplayPreview = cpMeta.isFamily || isYoutube && isEmbeddable && !isYoutubeRestrictedAge;
	      var shouldDisplayPlayCount = playCountInt > 0;
	      var isHot = playCountInt > 99999;
	      var cpType = cpMeta.type;
	      var kakaoTVType = cpMeta.isFamily ? _this.kakaoTVType(clip.kakao_tv_playlist_id) : '';
	
	      return {
	        bifChannelURL: clip.bif_channel_url,
	        bifChannelId: clip.bif_channel_id,
	        clipId: clip.clip_id || '',
	        cp: cp,
	        cpURL: clip.bif_cp_url,
	        cpName: clip.cp_group_name || '',
	        cpType: cpType,
	        dateString: _this.formatDate(clip.reg_datetime || ''),
	        displayURL: displayURL,
	        dsid: dsid,
	        dupURL: _this.makeDupURL(dupCount, dupInfo.dup_docids),
	        duration: _this.toVideoTimeFormat(clip.play_time || "0"),
	        isAdult: isAdult,
	        isKakaoTVPlaylist: cpType === _index2['default'].CPTypes.CP_TYPE_KAKAOTV && kakaoTVType === _constants.PLAYLIST,
	        isHot: isHot,
	        isUserReportMode: isUserReportMode,
	        kakaoTVType: kakaoTVType,
	        kakaoTVPlaylistId: clip.kakao_tv_playlist_id,
	        kakaoTVPlaylistURL: clip.kakao_tv_playlist_url,
	        kakaoTVPlaylistName: clip.kakao_tv_playlist_name,
	        pdGradeIcon: pdGradeIcon,
	        dupCount: dupCount,
	        shouldDisplayPreview: shouldDisplayPreview,
	        shouldDisplayPlayCount: shouldDisplayPlayCount,
	        thumbURL: thumbURL,
	        title: _this.escapeNonTagString(clip.title),
	        totalPlayCount: totalPlayCount,
	        userName: clip.user_name,
	        videoId: clip.video_id,
	        isSMR: clip.is_smr === '1',
	        isOrgDoc: true
	      };
	    });
	  },
	
	  /**
	   *
	   * @param {Clip} clip
	   * @param {PlaylistItem} playlistItem
	   * @returns {PlayListTemplateData}
	   */
	  mapClipToPlaylistTemplateData: function mapClipToPlaylistTemplateData(clip, playlistItem) {
	    return _jquery2['default'].extend({}, playlistItem, {
	      isKakaoTVPlaylist: clip.isKakaoTVPlaylist && playlistItem.type !== _index2['default'].docTypes.KAKAO_POPULAR,
	      kakaoTVPlaylistName: clip.kakaoTVPlaylistName,
	      kakaoTVPlaylistURL: clip.kakaoTVPlaylistURL
	    });
	  },
	  playlistToClipFormat: function playlistToClipFormat(baseClip, apiResponse) {
	    var _this2 = this;
	
	    return _jquery2['default'].extend({}, apiResponse, {
	      documents: apiResponse.documents.map(function (clipData) {
	        return {
	          videoId: clipData.vid,
	          clipId: clipData.clipId,
	          cp: baseClip.cp,
	          cpName: baseClip.cpName,
	          dateString: _this2.formatDate(clipData.date),
	          title: clipData.title,
	          thumbURL: clipData.thumbnail,
	          displayURL: clipData.url,
	          dsid: clipData.dsid,
	          duration: clipData.playTime,
	          totalPlayCount: clipData.playCount ? _this2.addComma(clipData.playCount) : '',
	          s2Id: apiResponse.s2Id,
	          type: apiResponse.type,
	          cpType: baseClip.cpType,
	          isKakaoTVPlaylist: baseClip.isKakaoTVPlaylist,
	          bifChannelId: baseClip.bifChannelId,
	          isSMR: baseClip.isSMR,
	          isOrgDoc: false
	        };
	      })
	    });
	  }
	};
	
	exports['default'] = Converter;

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  width: 600,
	  height: 400,
	  autoplay: true,
	  service: 'daum_searchview',
	  profile: 'HIGH',
	  wmode: 'opaque',
	  style: { width: '620px', height: '347px' },
	  isKakaoTV: false
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _kakaotvPlayer = __webpack_require__(22);
	
	var _kakaotvPlayer2 = _interopRequireDefault(_kakaotvPlayer);
	
	var _events = __webpack_require__(7);
	
	var events = _interopRequireWildcard(_events);
	
	var _defaultConfigs = __webpack_require__(20);
	
	var _defaultConfigs2 = _interopRequireDefault(_defaultConfigs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _jquery2['default'].extend(_kakaotvPlayer2['default'], {
	  events: events,
	  create: function create(configs) {
	    return new _kakaotvPlayer2['default'](_jquery2['default'].extend({}, _defaultConfigs2['default'], configs));
	  }
	});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _eventEmitter = __webpack_require__(3);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _inherit = __webpack_require__(2);
	
	var _inherit2 = _interopRequireDefault(_inherit);
	
	var _iframe = __webpack_require__(37);
	
	var _iframe2 = _interopRequireDefault(_iframe);
	
	var _events = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $template = _jquery2['default'].templates(_iframe2['default']);
	
	function KakaoTVPlayer(configs) {
	  _eventEmitter2['default'].call(this);
	  this.configs = configs;
	  this.$playerIframe = null;
	}
	
	_jquery2['default'].extend(KakaoTVPlayer, {
	  host: function host() {
	    return 'https://kakaotv.daum.net';
	  },
	  boolToBin: function boolToBin(bool) {
	    return bool ? 1 : 0;
	  },
	  makeParams: function makeParams(_ref) {
	    var autoplay = _ref.autoplay,
	        service = _ref.service,
	        profile = _ref.profile,
	        wmode = _ref.wmode;
	
	    return _jquery2['default'].param({
	      autoplay: KakaoTVPlayer.boolToBin(autoplay),
	      service: service,
	      profile: profile,
	      wmode: wmode
	    });
	  },
	  makeSourceURL: function makeSourceURL(videoId, _ref2) {
	    var autoplay = _ref2.autoplay,
	        service = _ref2.service,
	        profile = _ref2.profile,
	        wmode = _ref2.wmode;
	
	    var host = KakaoTVPlayer.host();
	    var params = KakaoTVPlayer.makeParams({ autoplay: autoplay, service: service, profile: profile, wmode: wmode });
	    return host + '/embed/player/cliplink/' + videoId + '@my?' + params;
	  }
	});
	
	(0, _inherit2['default'])(KakaoTVPlayer, _eventEmitter2['default'], {
	  createIframe: function createIframe(_ref3) {
	    var _this = this;
	
	    var videoId = _ref3.videoId,
	        title = _ref3.title;
	
	    this.$playerIframe = (0, _jquery2['default'])($template.render({
	      src: KakaoTVPlayer.makeSourceURL(videoId, this.configs),
	      title: _jquery2['default'].string.stripTags(title),
	      width: this.configs.width,
	      height: this.configs.height,
	      style: _jquery2['default'].map(this.configs.style, function (val, key) {
	        return key + ':' + val;
	      }).join(';')
	    }));
	    this.emit(_events.LOAD);
	    this.$playerIframe.one('load', function (e) {
	      _this.emit(_events.READY, e);
	    });
	    this.$playerIframe.one('error', function (e) {
	      _this.emit(_events.ERROR, e);
	    });
	
	    return this.$playerIframe;
	  },
	  load: function load($container, _ref4) {
	    var videoId = _ref4.videoId,
	        title = _ref4.title;
	
	    if (this.$playerIframe) {
	      this.destroy();
	    }
	    var $player = this.createIframe({ videoId: videoId, title: title });
	    $container.html($player);
	  },
	  destroy: function destroy() {
	    if (this.$playerIframe) {
	      this.$playerIframe.remove();
	      this.$playerIframe = null;
	      this.emit(_events.DESTROY);
	    }
	  }
	});
	
	exports['default'] = KakaoTVPlayer;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _eventEmitter = __webpack_require__(3);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _inherit = __webpack_require__(2);
	
	var _inherit2 = _interopRequireDefault(_inherit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function VideoCollection() {
	  var initialData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  _eventEmitter2['default'].call(this);
	  this.collection = initialData.map(function (each, idx) {
	    each.index = idx;
	    return each;
	  });
	  this.relatedClips = {};
	  this.length = initialData.length;
	}
	
	(0, _inherit2['default'])(VideoCollection, _eventEmitter2['default'], {
	  /**
	   * 기본적으로는 Array.prototype.filter와 동일
	   * 중간에 break 하는게 나아서 만듦
	   * @param {Function} condition
	   * @returns {Clip}
	   */
	  getClip: function getClip(condition) {
	    var coll = this.collection;
	    var len = coll.length;
	    for (var i = 0; i < len; i++) {
	      var clip = coll[i];
	      if (condition(clip, i)) {
	        return clip;
	      }
	    }
	  },
	  get: function get(_ref) {
	    var id = _ref.id,
	        where = _ref.where;
	
	    return where === 'playlist' ? this.relatedClips[id] : this.getClip(function (clip) {
	      return clip.videoId === id;
	    });
	  },
	  getByIndex: function getByIndex(idx) {
	    return this.collection[idx];
	  },
	  getAssignedClip: function getAssignedClip(key) {
	    return this.collection[key];
	  },
	  addIndex: function addIndex(clips) {
	    var _this = this;
	
	    return clips.map(function (clip) {
	      _this.length++;
	      clip.index = _this.length - 1;
	      return clip;
	    });
	  },
	  push: function push(clips, callback) {
	    var clipsIndexAdded = this.addIndex(clips);
	    this.collection = this.collection.concat(clipsIndexAdded);
	    this.emit('push', clipsIndexAdded, callback);
	  },
	  assign: function assign(key, value) {
	    this.relatedClips[key] = value;
	    this.emit('assign', value);
	  },
	  update: function update(clip, newProperties) {
	    this.emit('update', _jquery2['default'].extend(clip, newProperties));
	  },
	  on: function on() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _eventEmitter2['default'].prototype.on.apply(this, args);
	    return this;
	  }
	});
	
	exports['default'] = VideoCollection;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _defaultTemplate = __webpack_require__(38);
	
	var _defaultTemplate2 = _interopRequireDefault(_defaultTemplate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $template = _jquery2['default'].templates(_defaultTemplate2['default']);
	
	exports['default'] = {
	  selectors: {
	    btnPrev: '.btn_prev',
	    btnNext: '.btn_next',
	    playList: '.list_vclip',
	    items: '[data-vid]'
	  },
	  classNames: {
	    off: 'btn_off'
	  },
	  itemsInPage: 4,
	  initialPage: 1,
	  render: function render(templateData) {
	    return $template.render(templateData);
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _playlist = __webpack_require__(26);
	
	var _playlist2 = _interopRequireDefault(_playlist);
	
	var _defaultConfigs = __webpack_require__(24);
	
	var _defaultConfigs2 = _interopRequireDefault(_defaultConfigs);
	
	var _events = __webpack_require__(8);
	
	var events = _interopRequireWildcard(_events);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _jquery2['default'].extend(_playlist2['default'], {
	  events: events,
	  create: function create(configs) {
	    return new _playlist2['default'](_jquery2['default'].extend({}, _defaultConfigs2['default'], configs));
	  }
	});

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _eventEmitter = __webpack_require__(3);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _inherit = __webpack_require__(2);
	
	var _inherit2 = _interopRequireDefault(_inherit);
	
	var _events = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function PlayList(configs) {
	  _eventEmitter2['default'].call(this);
	  this.configs = configs;
	
	  this.templateData = null;
	  this.$html = null;
	  this.$playlist = null;
	  this.$items = null;
	
	  this.itemsInPage = this.configs.itemsInPage;
	  this.currentPage = this.configs.initialPage;
	}
	
	_jquery2['default'].extend(PlayList, {
	  extendNavigateEvent: function extendNavigateEvent(e, props) {
	    return _jquery2['default'].extend(e, {
	      detail: props
	    });
	  }
	});
	
	(0, _inherit2['default'])(PlayList, _eventEmitter2['default'], {
	  /**
	   *
	   * @param {PlayListTemplateData} templateData
	   * @returns {jQuery}
	   */
	  render: function render(templateData) {
	    this.templateData = templateData;
	    this.$html = (0, _jquery2['default'])(this.configs.render(templateData));
	    this.$playlist = this.$html.find(this.configs.selectors.playList);
	    this.$items = this.$html.find(this.configs.selectors.items);
	    this.bindEvents();
	    return this.$html;
	  },
	  destroy: function destroy() {
	    if (this.$html) {
	      this.$html.remove();
	      this.$html = null;
	      this.$playlist = null;
	      this.$items = null;
	      this.templateData = null;
	      this.currentPage = 1;
	    }
	  },
	
	  /**
	   * 페이지를 입력하면 해당 페이지의 리스트를 출력한다.
	   * 한번에 최대 this.itemsInPage 만큼만 그리는데, css가 first-child만 마진을 없애주고 있어서 그렇다.
	   * 리팩토링 전에는 전체 리스트를 다시 소팅 하는 방식이었다.
	   * @param {number} p - 1-indexed integer
	   */
	  goToPage: function goToPage(p) {
	    var $items = this.$items;
	    var maxPage = Math.ceil($items.length / this.itemsInPage);
	    var index = Math.min(Math.max(p, 1), maxPage) - 1;
	    var startIndex = index * this.itemsInPage;
	    var $itemsToShow = $items.slice(startIndex, startIndex + this.itemsInPage);
	    this.$html.find(this.configs.selectors.playList).html($itemsToShow);
	    this.currentPage = index + 1;
	  },
	  next: function next() {
	    this.goToPage(this.currentPage + 1);
	  },
	  prev: function prev() {
	    this.goToPage(this.currentPage - 1);
	  },
	  hasNext: function hasNext() {
	    var $items = this.$items;
	    return this.currentPage !== Math.ceil($items.length / this.itemsInPage);
	  },
	  hasPrev: function hasPrev() {
	    return this.currentPage > 1;
	  },
	  bindEvents: function bindEvents() {
	    this.bindNavigationButtonClickEvents();
	    this.bindItemClickEvents();
	  },
	
	  /**
	   * 플레이리스트 페이징을 할때마다 현재 페이지를 체크한다. 이전, 다음 페이지가 없으면 비활성화 표시
	   */
	  toggleNavButtonView: function toggleNavButtonView() {
	    var offClassName = this.configs.classNames.off;
	    var $btnPrev = this.$html.find(this.configs.selectors.btnPrev);
	    var $btnNext = this.$html.find(this.configs.selectors.btnNext);
	    this.hasPrev() ? $btnPrev.removeClass(offClassName) : $btnPrev.addClass(offClassName);
	    this.hasNext() ? $btnNext.removeClass(offClassName) : $btnNext.addClass(offClassName);
	  },
	
	
	  /**
	   *
	   * @emits navigate
	   */
	  bindNavigationButtonClickEvents: function bindNavigationButtonClickEvents() {
	    var _this = this;
	
	    var activeBtnPrevSelector = this.configs.selectors.btnPrev + ':not(.' + this.configs.classNames.off + ')';
	    var activeBtnNextSelector = this.configs.selectors.btnNext + ':not(.' + this.configs.classNames.off + ')';
	    this.$html.on('click', activeBtnPrevSelector, function (e) {
	      _this.prev();
	      _this.toggleNavButtonView();
	      _this.emit(_events.NAVIGATE, PlayList.extendNavigateEvent(e, { delta: -1, page: _this.currentPage }));
	    });
	    this.$html.on('click', activeBtnNextSelector, function (e) {
	      _this.next();
	      _this.toggleNavButtonView();
	      _this.emit(_events.NAVIGATE, PlayList.extendNavigateEvent(e, { delta: 1, page: _this.currentPage }));
	    });
	  },
	  bindItemClickEvents: function bindItemClickEvents() {
	    var _this2 = this;
	
	    this.$html.on('click', this.configs.selectors.items, function (e) {
	      _this2.emit(_events.ITEM_CLICK, e);
	    });
	  }
	});
	
	exports['default'] = PlayList;

/***/ },
/* 27 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  width: '100%',
	  height: '100%'
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _youtube = __webpack_require__(29);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _events = __webpack_require__(9);
	
	var events = _interopRequireWildcard(_events);
	
	var _defaultConfigs = __webpack_require__(27);
	
	var _defaultConfigs2 = _interopRequireDefault(_defaultConfigs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _jquery2['default'].extend(_youtube2['default'], {
	  events: events,
	  create: function create(containerId, configs) {
	    return new _youtube2['default'](containerId, _jquery2['default'].extend({}, _defaultConfigs2['default'], configs));
	  }
	});

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _eventEmitter = __webpack_require__(3);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _inherit = __webpack_require__(2);
	
	var _inherit2 = _interopRequireDefault(_inherit);
	
	var _events = __webpack_require__(9);
	
	var events = _interopRequireWildcard(_events);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function YoutubePlayer(containerId, configs) {
	  _eventEmitter2['default'].call(this);
	  this.containerId = containerId;
	  this.configs = configs;
	  this.isInitialLoad = true;
	  this.player = null;
	}
	
	(0, _inherit2['default'])(YoutubePlayer, _eventEmitter2['default'], {
	  eventCallbacks: function eventCallbacks() {
	    var _this = this;
	
	    return {
	      events: {
	        onReady: function onReady(e) {
	          return _this.emit(events.READY, e);
	        },
	        onStateChange: function onStateChange(e) {
	          return _this.emit(events.STATE_CHANGE, e);
	        },
	        onError: function onError(e) {
	          return _this.emit(events.ERROR, e);
	        }
	      }
	    };
	  },
	  load: function load(videoId) {
	    var _this2 = this;
	
	    if (this.isInitialLoad) {
	      SF.loadModule('youtube', function (status) {
	        if (status === 'success') {
	          _this2.emit(events.LOAD, videoId);
	          _this2.isInitialLoad = false;
	        } else {
	          _this2.emit(events.ERROR, new Error('Failed to load Youtube Iframe API script'));
	        }
	      });
	    } else {
	      // YT.Player.destroy가 내부적으로 setTimeout을 쓰는 듯 보인다.
	      // 바로 load이벤트를 실행할 경우 완전히 destroy 사이클이 끝나기 전에 다시 플레이어를 실행시켜 에러가 생긴다.
	      setTimeout(function () {
	        _this2.emit(events.LOAD, videoId);
	      }, 0);
	    }
	  },
	  play: function play(videoId) {
	    var _this3 = this;
	
	    var options = _jquery2['default'].extend({}, this.configs, this.eventCallbacks(), { videoId: videoId });
	    if (this.isInitialLoad) {
	      window.onYouTubeIframeAPIReady = function () {
	        return _this3.player = new window.YT.Player(_this3.containerId, options);
	      };
	    } else {
	      this.player = new window.YT.Player(this.containerId, options);
	    }
	  },
	  destroy: function destroy() {
	    if (this.player) {
	      this.player.destroy();
	      this.player = null;
	      this.emit(events.DESTROY);
	    }
	  }
	});
	exports['default'] = YoutubePlayer;

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	// 카카오 계열 CP 코드
	var KAKAOTV_NO_LIVE = exports.KAKAOTV_NO_LIVE = '0kakaotv';
	var KAKAOTV_OPEN = exports.KAKAOTV_OPEN = 'kakaotvO';
	var DAUM_CAFE = exports.DAUM_CAFE = '0000cafe';
	var TISTORY = exports.TISTORY = '0tistory';
	var DAUM_BLOG = exports.DAUM_BLOG = 'daumblog';
	
	// 그외 제휴, 유튜브 등
	var YOUTUBE = exports.YOUTUBE = '7b479cb3';
	var NAVER_BLOG = exports.NAVER_BLOG = '2d1cf605';
	var ETC = exports.ETC = '7b9fecb6';
	var YOUTUBE_CHANNEL_ID = exports.YOUTUBE_CHANNEL_ID = '1963';

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.togglePlayerLog = togglePlayerLog;
	exports.foldLog = foldLog;
	exports.unfoldLog = unfoldLog;
	exports.playlistLog = playlistLog;
	exports.staticLogs = staticLogs;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _cpMeta = __webpack_require__(4);
	
	var _cpMeta2 = _interopRequireDefault(_cpMeta);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _CPMeta$CPTypes = _cpMeta2['default'].CPTypes,
	    CP_TYPE_YOUTUBE = _CPMeta$CPTypes.CP_TYPE_YOUTUBE,
	    CP_TYPE_KAKAOTV = _CPMeta$CPTypes.CP_TYPE_KAKAOTV;
	var _CPMeta$codes = _cpMeta2['default'].codes,
	    KAKAOTV_NO_LIVE = _CPMeta$codes.KAKAOTV_NO_LIVE,
	    YOUTUBE = _CPMeta$codes.YOUTUBE,
	    YOUTUBE_CHANNEL_ID = _CPMeta$codes.YOUTUBE_CHANNEL_ID;
	var noop = _jquery2['default'].noop;
	
	/**
	 * 클릭로그 파라미터 스트링을 생성한다.
	 * @param {Object} params
	 * @returns {string}
	 */
	
	function param(params) {
	  return _jquery2['default'].param(_jquery2['default'].extend({}, { dc: 'VO2', pg: 1, at: 'func' }, params));
	}
	
	function extParamFactory(_ref) {
	  var cpId = _ref.cpId,
	      channelId = _ref.channelId,
	      isSMR = _ref.isSMR;
	
	  return {
	    vclip: {
	      bif_cp_id: cpId,
	      bif_channel_id: channelId,
	      is_smr: typeof isSMR === 'boolean' ? isSMR ? '1' : '-1' : '',
	      is_live: '-1'
	    }
	  };
	}
	
	/**
	 * 같은 위치의 객체지만 플레이어를 여는지 닫는지에 따라 p값이 달라진다.
	 * 같은 기능이라도 썸네일인지, 타이틀인지에 따라 p값이 달라진다.
	 *
	 * @param {MouseEvent} e
	 * @param {boolean} isCloseAction
	 * @param {number} clipsCount
	 * @param {Clip} clip
	 * @param {HTMLElement} currentTarget
	 */
	function togglePlayerLog(e, isCloseAction, clipsCount, clip, currentTarget) {
	  var isTab = SF.getParam('w') === 'vclip';
	  var isTitle = !(0, _jquery2['default'])(currentTarget).hasClass('thumb');
	
	  /**
	   *
	   * 통검은 썸네일, 타이틀 클릭 여부와 관계없이 22로 같은 p값
	   * 탭은 썸네일일경우 22, 타이틀일경우 32를 보냄
	   */
	  var p = void 0;
	  if (isCloseAction) {
	    p = isTab ? 12 : 9;
	  } else {
	    p = isTab ? isTitle ? 32 : 22 : 22;
	  }
	
	  var params = param({
	    p: p,
	    r: clip.index + 1,
	    rc: clipsCount,
	    d: clip.dsid
	  });
	
	  var extParams = extParamFactory({
	    cpId: clip.cp,
	    channelId: clip.bifChannelId,
	    isSMR: clip.isSMR
	  });
	
	  smartLog(e.currentTarget, params, e, extParams);
	}
	
	function foldLog(e) {
	  smartLog(e.currentTarget, param({ e: 23 }), e);
	}
	
	function unfoldLog(e) {
	  smartLog(e.currentTarget, param({ e: 13 }), e);
	}
	
	/**
	 * 플레이어 하단의 추천영상/플레이리스트 영상 목록 아이템을 클릭했을 때 보내는 로그
	 *
	 * - 카카오 추천영상의 경우 vid 기반으로 smr 여부를 알 수 없다고 하여 별도의 분기가 필요하다.
	 *
	 * @param {number} rc
	 * @param {Clip} clip
	 * @param {MouseEvent} evt
	 */
	function playlistLog(_ref2) {
	  var rc = _ref2.rc,
	      clip = _ref2.clip,
	      evt = _ref2.evt;
	  var cpType = clip.cpType,
	      isKakaoTVPlaylist = clip.isKakaoTVPlaylist,
	      bifChannelId = clip.bifChannelId,
	      index = clip.index,
	      dsid = clip.dsid,
	      videoId = clip.videoId,
	      isSMR = clip.isSMR;
	
	
	  var isKakaoTV = cpType === CP_TYPE_KAKAOTV;
	  var isYoutube = cpType === CP_TYPE_YOUTUBE;
	  var params = param({
	    at: 'func',
	    p: isKakaoTVPlaylist ? 26 : 25,
	    rc: rc,
	    r: index + 1,
	    d: isYoutube ? dsid : videoId
	  });
	
	  var extLogParam = function () {
	    switch (true) {
	      case isKakaoTVPlaylist:
	        return extParamFactory({
	          cpId: KAKAOTV_NO_LIVE,
	          channelId: bifChannelId,
	          isSMR: isSMR
	        });
	      case isKakaoTV:
	        return extParamFactory({
	          cpId: KAKAOTV_NO_LIVE,
	          channelId: '',
	          isSMR: ''
	        });
	      case isYoutube:
	        return extParamFactory({
	          cpId: YOUTUBE,
	          channelId: YOUTUBE_CHANNEL_ID,
	          isSMR: false
	        });
	      default:
	        return null;
	    }
	  }();
	
	  smartLog(evt.target, params, evt, extLogParam);
	}
	
	/**
	 * 동일한 영역에 p값이 변하지 않는 모든 로그를 바인딩 한다.
	 * p값은 스태틱 하더라도 extParam은 로직에 따라 다르게 넣어줘야 한다.
	 *
	 * @param {jQuery} $ctx - 클릭로그 이벤트 루트가 될 jQuery 객체, 기본적으로 $('#vclipColl')
	 * @param {function(number|string):Clip} getClipByIndex
	 * @param {function():number} getResultCount
	 * @param {function():Clip} nowPlaying
	 * @param {object} definitions
	 */
	function staticLogs($ctx, _ref3) {
	  var _ref3$getClipByIndex = _ref3.getClipByIndex,
	      getClipByIndex = _ref3$getClipByIndex === undefined ? noop : _ref3$getClipByIndex,
	      _ref3$getResultCount = _ref3.getResultCount,
	      getResultCount = _ref3$getResultCount === undefined ? noop : _ref3$getResultCount,
	      _ref3$nowPlaying = _ref3.nowPlaying,
	      nowPlaying = _ref3$nowPlaying === undefined ? noop : _ref3$nowPlaying,
	      definitions = _ref3.definitions;
	
	  $ctx.on('click', '[data-p]', function (e) {
	    var $elem = (0, _jquery2['default'])(this);
	    var data = $elem.data();
	    var elementIndex = $ctx.find('[data-type]').index($elem.closest('[data-type]'));
	    var clip = elementIndex < 0 ? nowPlaying() : getClipByIndex(elementIndex); // 플레이어영역의 경우 elementIndex로는 받아올 수 없다.
	    var _definitions$data$p = definitions[data.p],
	        at = _definitions$data$p.at,
	        p = _definitions$data$p.p,
	        dc = _definitions$data$p.dc,
	        extend = _definitions$data$p.extend,
	        extParamSetter = _definitions$data$p.extParamSetter;
	
	
	    var paramObj = _jquery2['default'].extend({
	      at: at,
	      p: p,
	      r: clip ? clip.index + 1 : 1,
	      rc: getResultCount(),
	      d: clip ? clip.dsid : '',
	      dc: dc || 'VO2'
	    }, typeof extend === 'function' ? extend({ event: event, target: this }) : {});
	
	    var params = param(paramObj);
	
	    var extParams = function () {
	      switch (true) {
	        case typeof clip === 'undefined':
	          return null;
	        case typeof extParamSetter === 'function':
	          return extParamFactory(extParamSetter(clip));
	        default:
	          return extParamFactory({
	            cp: clip.cp,
	            channelId: clip.bifChannelId,
	            isSMR: clip.isSMR
	          });
	      }
	    }();
	
	    smartLog(this, params, e, extParams);
	
	    // 클릭로그 u 리디렉팅이 서비스 구모듈에서 작동하지 않아 임의로 넣어둠
	    // 2018.03.29에 정기배포후 필요없어질 코드
	    if (paramObj.u) {
	      setTimeout(function () {
	        window.location.href = paramObj.u;
	      }, 350);
	    }
	  });
	}
	
	/**
	 * @typedef {Object} extParams
	 * @property {string} bif_cp_id
	 * @property {string} bif_channel_id
	 * @property {string} is_smr
	 * @property {string} is_live
	 */
	/**
	 * 통검은 썸네일, 타이틀 클릭 여부와 관계없이 22로 같은 p값
	 * 탭은 썸네일일경우 32, 타이틀일경우 22를 보냄
	 */

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.sendS2Log = exports.staticLogs = exports.playlistLog = exports.unfoldLog = exports.foldLog = exports.togglePlayerLog = undefined;
	
	var _clickLog = __webpack_require__(31);
	
	var _s2Log = __webpack_require__(33);
	
	exports.togglePlayerLog = _clickLog.togglePlayerLog;
	exports.foldLog = _clickLog.foldLog;
	exports.unfoldLog = _clickLog.unfoldLog;
	exports.playlistLog = _clickLog.playlistLog;
	exports.staticLogs = _clickLog.staticLogs;
	exports.sendS2Log = _s2Log.sendS2Log;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.sendS2Log = sendS2Log;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _types = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *
	 * @param {s2LogData}  nextClip
	 * @param {Clip}  nowPlaying
	 * @returns {string}
	 */
	function makeLogURL(nextClip, nowPlaying) {
	  var dsid = nextClip.dsid,
	      s2Id = nextClip.s2Id,
	      cpType = nextClip.cpType,
	      clipId = nextClip.clipId;
	
	  var isYoutube = cpType === _types.CP_TYPE_YOUTUBE;
	  var isKakao = cpType === _types.CP_TYPE_KAKAOTV;
	
	  return SF.getQsUrl({
	    w: 'vclip',
	    uuid: window.uuid,
	    m: 'ft_proxy',
	    q: '',
	    id: isYoutube ? dsid : clipId,
	    source: isYoutube ? nowPlaying.dsid : nowPlaying.clipId,
	    s2Id: s2Id,
	    type: isYoutube ? 'ytlog' : isKakao ? 'tvlog' : cpType
	  }, 1);
	}
	
	/**
	 *
	 * @param {s2LogData} nextClip
	 * @param {Clip} nowPlaying
	 */
	function sendS2Log(nextClip, nowPlaying) {
	  if (!nextClip.s2Id) {
	    return;
	  }
	
	  var url = makeLogURL(nextClip, nowPlaying);
	
	  _jquery2['default'].ajax({ contentType: 'text/html', url: url });
	}
	
	/**
	 *
	 * @typedef {Object} s2LogData
	 * @property {PlaylistItem.dsid|string} dsid
	 * @property {PlaylistItem.videoId|string} videoId
	 * @property {PlayListAPI.s2Id|string} s2Id
	 * @property {PlaylistItem.cpType|string} cpType
	 */

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  autoplayKakao: true,
	  autoplayYoutube: false,
	  playerWrapperId: 'vclipIframePlayer',
	  playlistSelector: '.player_foot'
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _videoPlayer = __webpack_require__(36);
	
	var _videoPlayer2 = _interopRequireDefault(_videoPlayer);
	
	var _events = __webpack_require__(11);
	
	var events = _interopRequireWildcard(_events);
	
	var _defaultConfigs = __webpack_require__(34);
	
	var _defaultConfigs2 = _interopRequireDefault(_defaultConfigs);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _jquery2['default'].extend(_videoPlayer2['default'], {
	  events: events,
	  create: function create(configs) {
	    return new _videoPlayer2['default'](_jquery2['default'].extend({}, _defaultConfigs2['default'], configs));
	  }
	});

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _eventEmitter = __webpack_require__(3);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _inherit = __webpack_require__(2);
	
	var _inherit2 = _interopRequireDefault(_inherit);
	
	var _videoPlaylist = __webpack_require__(25);
	
	var _videoPlaylist2 = _interopRequireDefault(_videoPlaylist);
	
	var _player = __webpack_require__(39);
	
	var _player2 = _interopRequireDefault(_player);
	
	var _events = __webpack_require__(11);
	
	var _constants = __webpack_require__(5);
	
	var _youtubePlayer = __webpack_require__(28);
	
	var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
	
	var _kakaotvUrlPlayer = __webpack_require__(21);
	
	var _kakaotvUrlPlayer2 = _interopRequireDefault(_kakaotvUrlPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $template = _jquery2['default'].templates(_player2['default']);
	
	function VideoPlayer(_ref) {
	  var autoplayYoutube = _ref.autoplayYoutube,
	      autoplayKakao = _ref.autoplayKakao,
	      playerWrapperId = _ref.playerWrapperId,
	      playlistSelector = _ref.playlistSelector;
	
	  _eventEmitter2['default'].call(this);
	
	  // initial state setting 
	  this.$player = null;
	  this.history = [];
	  this.autoplayYoutube = autoplayYoutube;
	  this.autoplayKakao = autoplayKakao;
	  this.playerWrapperId = playerWrapperId;
	  this.playlistSelector = playlistSelector;
	  this.isPlaying = false;
	
	  // core module instance
	  this._playlist = _videoPlaylist2['default'].create();
	  this._youtubePlayer = _youtubePlayer2['default'].create(playerWrapperId);
	  this._kakaoTVPlayer = _kakaotvUrlPlayer2['default'].create({ autoplay: this.autoplayKakao });
	
	  // player event binding
	  this._bindYoutubePlayerEvents();
	  this._bindKakaoTVPlayerEvents();
	  this._bindPlayListEvents();
	}
	
	(0, _inherit2['default'])(VideoPlayer, _eventEmitter2['default'], {
	  _bindPlayListEvents: function _bindPlayListEvents() {
	    var _this = this;
	
	    var pl = this._playlist;
	    var eType = _videoPlaylist2['default'].events;
	    pl.on(eType.ITEM_CLICK, function (e) {
	      var videoId = (0, _jquery2['default'])(e.currentTarget).data('vid');
	      var clipData = pl.templateData.documents.filter(function (data) {
	        return data.videoId === videoId;
	      })[0];
	      var nowPlaying = _this.nowPlaying();
	
	      // 플레이어를 바로 닫으면 이벤트 위임할 수 없게 되므로 타임아웃으로 비동기 처리한다
	      setTimeout(function () {
	        // 현재 플레이어의 객체에 새롭게 재생할 데이터를 오버라이딩한다.
	        // API 콜을 하면 모든 데이터를 내려주지 않기 때문에 필요한 데이터만 덮어 쓴다.
	        _this.close().open(_jquery2['default'].extend({}, nowPlaying, clipData), true);
	        _this.emit(_events.SWITCH, _jquery2['default'].extend(e, { detail: { clipData: clipData, nowPlaying: nowPlaying } }));
	      }, 0);
	    });
	    pl.on(eType.NAVIGATE, function (e) {
	      _this.emit(_events.NAVIGATE, e);
	    });
	  },
	  _bindYoutubePlayerEvents: function _bindYoutubePlayerEvents() {
	    var _this2 = this;
	
	    var yp = this._youtubePlayer;
	    var eType = _youtubePlayer2['default'].events;
	    yp.on(eType.READY, function (e) {
	      _this2.autoplayYoutube && e.target.playVideo();
	      _this2.emit(_events.READY, { event: e, type: _constants.YOUTUBE });
	    });
	    yp.on(eType.LOAD, function (videoId) {
	      yp.play(videoId);
	    });
	    yp.on(eType.DESTROY, function () {
	      _this2.emit(_events.DESTROY);
	    });
	  },
	  _bindKakaoTVPlayerEvents: function _bindKakaoTVPlayerEvents() {
	    var _this3 = this;
	
	    var kp = this._kakaoTVPlayer;
	    var eType = _kakaotvUrlPlayer2['default'].events;
	    kp.on(eType.LOAD, function () {
	      _this3.emit(_events.LOAD);
	    });
	    kp.on(eType.READY, function (e) {
	      _this3.emit(_events.READY, { event: e, type: _constants.KAKAOTV });
	    });
	    kp.on(eType.DESTROY, function () {
	      _this3.emit(_events.DESTROY);
	    });
	  },
	
	  /**
	   * 플레이어 DOM 영역이 그려져있다면 삭제한다.
	   * @private
	   */
	  _destroy: function _destroy() {
	    this.$player && this.$player.remove();
	  },
	
	  /**
	   * 템플릿을 그린 뒤 jQuery 인스턴스로 파싱한다.
	   * @param {PlayerTemplateData} clip
	   * @private
	   */
	  _renderPlayer: function _renderPlayer(clip) {
	    var templateData = _jquery2['default'].extend({}, clip, { playerId: this.playerWrapperId });
	    this.$player = (0, _jquery2['default'])($template.render(templateData));
	  },
	  nowPlaying: function nowPlaying() {
	    return this.history.slice(-1).pop();
	  },
	
	  /**
	   * 현재 생성된 iFrame DOM 엘리먼트 또는 Div를 잡아온다. js로 그렸다 지우는 DOM이기 때문에 매번 잡아온다.
	   * @returns { jQuery }
	   */
	  getPlayer$: function getPlayer$() {
	    return this.$player.find('#' + this.playerWrapperId);
	  },
	
	
	  /**
	   * 플레이어를 로드한다.
	   * @param {Object} clip
	   * @param {string} clip.cpType
	   * @param {string} clip.title
	   */
	  loadPlayer: function loadPlayer(_ref2) {
	    var cpType = _ref2.cpType,
	        videoId = _ref2.videoId,
	        title = _ref2.title;
	
	    if (cpType === _constants.YOUTUBE) {
	      this._youtubePlayer.load(videoId);
	    } else {
	      this._kakaoTVPlayer.load(this.getPlayer$(), { videoId: videoId, title: title });
	    }
	  },
	
	  /**
	   *
	   * @param clip
	   * @returns {VideoPlayer}
	   */
	  open: function open(clip) {
	    this._renderPlayer(clip);
	    this.loadPlayer(clip);
	    this.history.push(clip);
	    this.isPlaying = true;
	    this.emit(_events.OPEN, clip);
	    return this;
	  },
	
	
	  /**
	   * 플레이어, 플레이리스트, 플레이어 컨테이너를 차례대로 dom에서 지운다.
	   * 동적으로 바인딩한 이벤트 리스너를 모두 지우기때문에 플레이어를 없애려면 반드시 이 메소드를 사용하여야한다.
	   * @returns {VideoPlayer}
	   */
	  close: function close() {
	    this.isPlaying = false;
	    this._youtubePlayer.destroy();
	    this._kakaoTVPlayer.destroy();
	    this._playlist.destroy();
	    this._destroy();
	    return this;
	  },
	
	
	  /**
	   * 체이닝을 위해 한번 감싸서 오버라이딩
	   * @override
	   * @param args
	   * @returns {VideoPlayer}
	   */
	  on: function on() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _eventEmitter2['default'].prototype.on.apply(this, args);
	    return this;
	  },
	
	
	  /**
	   * 재생목록을 그린다.
	   * @param {PlayListTemplateData} templateData
	   */
	  renderPlayList: function renderPlayList(templateData) {
	    this.$player.find(this.playlistSelector).replaceWith(this._playlist.render(templateData));
	  },
	
	
	  /**
	   * 하단 동영상 목록 영역을 없앤다.
	   * 플레이리스트를 불러오는 AJAX통신이 실패했을 경우 빈 영역이 그대로 남아있게 되므로, 해당영역을 지워줄 필요가 있다.
	   */
	  closeFooter: function closeFooter() {
	    if (this.$player) {
	      this.$player.find(this.playlistSelector).remove();
	    }
	  }
	});
	
	exports['default'] = VideoPlayer;

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = "<iframe src=\"{{:src}}\" title=\"{{:title}}\" width=\"{{:width}}\" height=\"{{:height}}\" style=\"{{:style}}\" allowfullscreen frameborder=\"0\" scrolling=\"no\"></iframe>";

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = "{{if documents.length > 0}}<div class=\"player_foot {{:isKakaoTVPlaylist ? '' : 'recomm_foot'}}\" style=\"font-size:12px\"> {{if isKakaoTVPlaylist}} <a target=\"_black\" href=\"{{:kakaoTVPlaylistURL}}\" class=\"tit\" data-p=\"28\">{{:kakaoTVPlaylistName}} <span class=\"more_vod\">{{:size}}개 영상 더보기<span class=\"ico_vclip ico_more\"></span></span></a> <span class=\"ico_vclip ico_more\">더보기</span> {{else}} <span class=\"tit\">추천영상</span> {{/if}}<span class=\"thumb_cover2\"></span><div class=\"item_list\"><div class=\"panel\"><ul class=\"list_vclip\"> {{for documents ~isKakaoTVPlaylist=isKakaoTVPlaylist}}<li data-vid=\"{{:videoId}}\"><a href=\"javascript:;\" class=\"link_thumb\"><div class=\"wrap_thumb\"> <span class=\"thumb\"><img src=\"{{:thumbURL}}\" class=\"thumb_img\" width=\"140\" height=\"79\" alt=\"\" onerror=\"SF.errorImage(this)\"><span class=\"thumb_frame\"></span> <span class=\"txt_time\">{{:duration}}</span></span></div><div class=\"wrap_cont\"> <span class=\"link\">{{:title}}</span> <span class=\"info\"><span class=\"f_tag\">{{:cpName}}</span> <span class=\"txt_bar\">&nbsp;|&nbsp;</span> <span class=\"f_tag\">{{:dateString}}</span></span></div></a></li> {{/for}}</ul></div><span class=\"thumb_cover\"></span></div><div class=\"wrap_btn buttonWarp\" id=\"vclip_additional_vclip_pannel\"> <a href=\"javascript:;\" class=\"ico_vclip btn_prev btn_off\" title=\"\">이전</a> <a href=\"javascript:;\" class=\"ico_vclip btn_next\" title=\"\">다음</a></div></div> {{/if}}";

/***/ },
/* 39 */
/***/ function(module, exports) {

	module.exports = "<li class=\"li_vod\" style=\"display: block\"><div class=\"vclip_player vclip_3grid\"><div class=\"player_inner\"><div class=\"player_main\"><div id=\"{{:playerId}}\" class=\"warp_player\"></div></div><div class=\"player_head\"> <strong class=\"tit\">{{if displayURL.length}} <a href=\"{{:displayURL}}\" target=\"_blank\" data-p=\"34\">{{:title}}</a> {{else}} {{:title}} {{/if}}</strong> <span class=\"info\">{{:cpName}} <span class=\"txt_bar\">|</span> {{:dateString}} {{if totalPlayCount}} <span class=\"txt_bar\">|</span> <span class=\"ico_vclip ico_play\">재생수</span>{{:totalPlayCount}} {{/if}}</span></div></div> {{!-- 이 영역은 플레이리스트 로딩시 대체 된다. 이 영역이 없을 경우 영역이 없다가 나타나는 증상이 생긴다. 영역이 깜빡거리는 현상을 완화하기 위해 기본 height값을 지정한다. --}}<div class=\"player_foot\" style=\"height:170px;\"><span class=\"thumb_cover2\"></span><div class=\"item_list\"><div class=\"panel\"><ul class=\"list_vclip\"><li class=\"addtional_vclip_dummy\"></li></ul></div><span class=\"thumb_cover\"></span></div><div class=\"wrap_btn buttonWarp\" id=\"vclip_additional_vclip_pannel\"> <a href=\"javascript:;\" class=\"ico_vclip btn_prev btn_off\" title=\"\">이전</a> <a href=\"javascript:;\" class=\"ico_vclip btn_next\" title=\"\">다음</a></div></div></div></li>";

/***/ },
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultOptions = exports.EXPAND = exports.FOLD = exports.MORE = undefined;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _clipListItem = __webpack_require__(46);
	
	var _clipListItem2 = _interopRequireDefault(_clipListItem);
	
	var _clipList = __webpack_require__(18);
	
	var _clipList2 = _interopRequireDefault(_clipList);
	
	var _inherit = __webpack_require__(2);
	
	var _inherit2 = _interopRequireDefault(_inherit);
	
	var _defaultConfigs = __webpack_require__(12);
	
	var _defaultConfigs2 = _interopRequireDefault(_defaultConfigs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MORE = exports.MORE = 'more';
	var FOLD = exports.FOLD = 'fold';
	var EXPAND = exports.EXPAND = 'expand';
	
	var defaultOptions = exports.defaultOptions = _jquery2['default'].extend({}, _defaultConfigs2['default'], {
	  template: _jquery2['default'].templates(_clipListItem2['default']),
	  expender: '',
	  viewCount: 5,
	  maxCount: 25
	});
	
	/**
	 * ClipList를 통검 펼쳐보기 공통 모듈인 SF.extend와 결합
	 *
	 * @see {@link http://hehet.dev.daum.net/scripts/modules/extend/index.html}
	 *
	 * @param opts
	 * @constructor
	 * @augments ClipList
	 */
	function ClipListExtend(opts) {
	  _clipList2['default'].call(this, opts);
	  var expender = opts.expender,
	      container = opts.container,
	      viewCount = opts.viewCount,
	      maxCount = opts.maxCount,
	      template = opts.template;
	
	
	  var self = this;
	  this.maxCount = maxCount || -1;
	  this.viewCount = viewCount;
	  this.page = 1;
	  this.$template = template;
	  this.isEnd = false;
	
	  this.extendModule = new SF.extend({
	    expender: expender,
	    container: container,
	    viewCount: viewCount,
	    source: function source(resolve) {
	      self.emit(MORE, function (clip) {
	        return self.renderToClipList(clip, resolve);
	      });
	    },
	    onFold: function onFold(e) {
	      self.page = 1;
	      self.emit(FOLD, _jquery2['default'].extend(e, { detail: { page: self.page } }));
	    },
	    onExpand: function onExpand(e) {
	      self.page++;
	      self.emit(EXPAND, _jquery2['default'].extend(e, { detail: { page: self.page } }));
	    }
	  });
	}
	
	_jquery2['default'].extend(ClipListExtend, {
	  events: _jquery2['default'].extend({}, _clipList2['default'].events, { MORE: MORE, FOLD: FOLD, EXPAND: EXPAND }),
	  create: function create(options) {
	    var opts = _jquery2['default'].extend({}, defaultOptions, options);
	    return new ClipListExtend(opts);
	  }
	});
	
	(0, _inherit2['default'])(ClipListExtend, _clipList2['default'], {
	  renderToClipList: function renderToClipList(clips, add) {
	    var responseLength = clips.length;
	    this.length += responseLength;
	    this.isEnd = this.isEnd || this.length >= this.maxCount;
	    add(this.renderList(clips), this.isEnd);
	  },
	  renderList: function renderList(templateData) {
	    var _this = this;
	
	    var td = templateData.map ? templateData : [templateData];
	    return td.map(function (data) {
	      return _this.$template.render(data);
	    }).join('');
	  }
	});
	
	exports['default'] = ClipListExtend;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.$document = exports.$listWrap = exports.$extendBtn = exports.$ctx = undefined;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// 콜렉션 컨텍스트
	var $ctx = exports.$ctx = (0, _jquery2['default'])('#vclipColl');
	// 펼쳐보기 버튼
	var $extendBtn = exports.$extendBtn = $ctx.find('.extend_comp');
	// 펼쳐보기 영역
	var $listWrap = exports.$listWrap = $ctx.find('#_vclipList');
	// 문서 전체 영역 (스크롤 애니메이션에 사용)
	var $document = exports.$document = (0, _jquery2['default'])('html, body');

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports = "<li data-type=\"{{:shouldDisplayPreview ? 'preview' : 'outlink'}}\"><div class=\"wrap_thumb {{:isAdult ? 'thumb_adult' : ''}}\"> <a href=\"{{:shouldDisplayPreview ? 'javascript:;' : displayURL}}\" target=\"_{{:shouldDisplayPreview ? 'self': 'blank'}}\" class=\"thumb\" data-vid=\"{{:videoId}}\" {{:shouldDisplayPreview ? '': 'data-p=\"21\"'}}><img src=\"{{:thumbURL}}\" class=\"thumb_img\" width=\"146\" height=\"83\" alt=\"\" onerror=\"SF.errorImage(this)\" data-size=\"146x83\"><span class=\"thumb_frame\"></span><div class=\"figcaption_bg\"> <span class=\"ico_vclip ico_play3\">동영상</span> {{if shouldDisplayPreview}} <span class=\"link_view btn_show\">바로보기</span><span class=\"btn_close\"><span class=\"ico_vclip ico_close\"></span> 플레이어 닫기</span> {{/if}} <span class=\"txt_time\">{{:duration}}</span></div></a></div><div class=\"wrap_cont\"><div class=\"wrap_tit\"> <a href=\"{{:shouldDisplayPreview ? 'javascript:;' : displayURL}}\" target=\"_{{:shouldDisplayPreview ? 'self' : 'blank'}}\" {{:isUserReportMode ? 'data-cnucc=\"VO2|\"' + dsid : ''}}\n         data-vid=\"{{:videoId}}\"\n         {{:shouldDisplayPreview ? '' : 'data-p=\"31\"'}}>{{:title}}</a> {{if isAdult && cp === '0kakaotv'}} <span class=\"ico_rwd ico_adult\">19세 이상 이용가능</span> {{/if}}</div><div class=\"f_nb info\"> <span class=\"f_l\">{{if dupCount > 1}} <a class=\"f_nb\" href=\"{{:dupURL}}\" data-p=\"11\">유사<strong>{{:dupCount}}</strong>건</a> <span class=\"txt_bar\">&nbsp;|&nbsp;</span> {{/if}} <a href=\"{{:cpURL}}\" class=\"f_nb\" target=\"_blank\" data-p=\"3\">{{:cpName}}</a> <span class=\"txt_bar\">&nbsp;|&nbsp;</span> <span class=\"f_nb\">{{:dateString}}</span> {{if shouldDisplayPlayCount}} <span class=\"txt_bar\">&nbsp;|&nbsp;</span> <span class=\"ico_vclip ico_vodplay\">재생 횟수</span> {{:totalPlayCount}} {{/if}} <span id=\"videoSQC_t1_{{:index}}\" style=\"display:none;\">50501^{{:dsid}}^{{:displayURL}}</span> <span id=\"videoSQC_t2_{{:index}}\" style=\"display:none;\">50502^{{:dsid}}^{{:displayURL}}</span></span> {{if isHot && shouldDisplayPlayCount}} <em class=\"ico_hot\">인기</em> {{/if}}</div> {{if kakaoTVPlaylistURL}}<div class=\"txt_count\"> {{if kakaoTVPlaylistURL}} <a href=\"{{:kakaoTVPlaylistURL}}\" class=\"f_blue\" target=\"_blank\" data-p=\"18\">{{:kakaoTVPlaylistName}} <span class=\"ico_rwd ico_more_s\">영상보기</span></a> {{/if}}</div> {{/if}}</div></li>";

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** vclip/VO2-tot.bundle.689bedd.js
 **/